import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { IndexedDBRepository } from './core/repositories/indexed_db_repository';
import { AnalyticsService } from './core/services/analytics.service';
import { UserStore } from './core/stores/user.store';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'sl' },
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideAppInitializer(() => {
      inject(AnalyticsService).init();

      // Construct UserStore now so its constructor kicks off GET /me/config at
      // bootstrap (via its internal queueMicrotask), instead of waiting for the
      // first component to inject it after the lazy route renders.
      inject(UserStore);

      const indexedDbRepository = inject(IndexedDBRepository);

      return indexedDbRepository.initDB().then(() => undefined);
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
};
